<template>
  <div>
    <template v-if="!userLogin()">
      <div id="main-card" class="card w-50 mx-auto p-5 d-flex align-items-center rounded shadow">
        <!--QRP LOGO START-->
        <div class="container h-100">
          <div class="row justify-content-md-center">
            <div class="col-12 mx-auto">
              <img id="qrp-logo" src="../../assets/qrp-rtm-color.svg" alt="QuinStreet Rating Platform" width="150px" height="auto" />
            </div>
          </div>
        </div>
        <!--QRP LOGO END-->
      <div id="card-inner-container" class="mx-auto w-100">
        <div class="row justify-content-md-center">
            <div class="col-12 col-lg-10 mt-5 mx-auto unlink page-404-color">
            <span class="fas fa-unlink fa-7x"></span>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-lg-10 mt-3 mx-auto text-center page-404-color">
              <div class="text-404-head">404 Page Not Found</div>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-lg-10 mt-1 mx-auto text-center page-404-color">
              <div class="text-404-label">We're sorry. It looks like this page does not exist.</div>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-lg-10 mt-4 mx-auto text-center">
              <button type="button" class="btn btn-primary" @click.prevent="$router.push({ path: '/' })">Login</button>
            </div>
        </div>
            </div>
      </div>
    </template>
    <template v-else>
      <main-header :userProfileData="userProfileData"></main-header>
      <div class="main">
      <div class="container-fluid w-100">
            <div class="row justify-content-md-center">
            <div class="col-12 col-lg-10 mt-5 mx-auto unlink page-404-color">
            <span class="fas fa-unlink fa-7x"></span>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-lg-10 mt-3 mx-auto text-center page-404-color">
              <div class="text-404-head">404 Page Not Found</div>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-lg-10 mt-1 mx-auto text-center page-404-color">
              <div class="text-404-label">We're sorry. It looks like this page does not exist.</div>
            </div>
        </div>
        </div>
        </div>
    </template>
</div>
</template>

<script>
import Header from '../shared/Header';

export default {
  data() {
    return {
      userProfileData: { firstName: '', lastName: '' },
    };
  },
  components: {
    mainHeader: Header,
  },
  mounted() {
    this.userProfileData.firstName = sessionStorage.getItem('userFirstName');
    this.userProfileData.lastName = sessionStorage.getItem('userLastName');
  },
  methods: {
    /**
     * check if user login
     */
    userLogin() {
      if (sessionStorage.getItem('userId')) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
.login-404 {
  background-color: #EEEEEE;
}
.unlink .fa-unlink {
  text-align: center;
  width: 100%;
}
.text-404-label {
  font-size: 24px;
  font-weight: normal;
}
.page-404-color {
  color: #666666;
  font-family: "Open Sans";
}
.text-404-head {
  font-size: 50px;
  font-weight: bold;
}
#main-card {
  border-color: #F7F7F7;
  margin-top: 4rem;
}

#login-card-hr {
  margin: 0.625rem 0;
}

#login-card-hr-bottom {
  margin-bottom: .25rem;
}

#qrp-logo{
  display: block;
  width: 100%;
  max-width: 230px;
  height: inherit !important;
  margin:0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/interview/NotFound.vue?7deb0f72